/**
 * Which edges of a horizontally scrolling row have content beyond them.
 *
 * Extracted from the component because the off-by-one is the whole difficulty:
 * sub-pixel layout rounding leaves `scrollLeft` a fraction short of its maximum
 * at the far end, so a naive `scrollLeft < max` keeps a fade showing forever at
 * a scroll end — the affordance then says "there is more" when there is not,
 * which is worse than no affordance at all.
 */
export interface ScrollEdges {
  left: boolean;
  right: boolean;
}

/** Sub-pixel tolerance, in CSS pixels. */
export const EDGE_TOLERANCE = 1;

export function edgeState(
  scrollLeft: number,
  scrollWidth: number,
  clientWidth: number,
): ScrollEdges {
  const maxScroll = scrollWidth - clientWidth;
  if (!Number.isFinite(maxScroll) || maxScroll <= EDGE_TOLERANCE) {
    // Nothing overflows: no edge to hint at, in either direction.
    return { left: false, right: false };
  }
  return {
    left: scrollLeft > EDGE_TOLERANCE,
    right: scrollLeft < maxScroll - EDGE_TOLERANCE,
  };
}
